import React, { useEffect, useContext, useState } from 'react';
import UI_Header from '../components/UI_Header';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../Contexts/AuthContext';
import { useAccounts } from '../Contexts/Context_Accounts';
import UI_Subwindows from '../components/UI_Subwindows';
import { Context_UI } from '../Contexts/Context_UI';
import Context_Provider_MapEditor from '../Contexts/Context_MapEditor';
import Context_Provider_Templating from '../Contexts/Context_Templating';
import Context_Provider_MapRenderer from '../Contexts/Context_MapRenderer';
import Context_Provider_Accounts from '../Contexts/Context_Accounts';
import Context_Provider_ScheduleManagement from '../Contexts/Context_ScheduleManagement';

import Subwindow_Modal_UnsavedChanges from '../components/Subwindow_Modal_UnsavedChanges';
import Subwindow_ScheduleManagement_Reserve from '../components/ScheduleManagement/Subwindow_ScheduleManagement_Reserve';
import Subwindow_ScheduleManagement_Attendees from '../components/ScheduleManagement/Subwindow_ScheduleManagement_Attendees';
import Subwindow_ScheduleManagement_Equipment from '../components/ScheduleManagement/Subwindow_ScheduleManagement_Equipment';
import Subwindow_ScheduleManagement_Map from '../components/ScheduleManagement/Subwindow_ScheduleManagement_Map';
import Subwindow_ScheduleManagement_Reservation_Success from '../components/ScheduleManagement/Subwindow_ScheduleManagement_Reservation_Success';
import Subwindow_ScheduleManagement_Document from '../components/ScheduleManagement/Subwindow_ScheduleManagement_Document';
import Subwindow_ScheduleManagement_Reservation_Reject from '../components/ScheduleManagement/Subwindow_ScheduleManagement_Reservation_Reject';
import Subwindow_ScheduleManagement_Conflict_Resolve_Standard from '../components/ScheduleManagement/Subwindow_ScheduleManagement_Conflict_Resolve_Standard';
import Subwindow_ScheduleManagement_Schedule_Reschedule from '../components/ScheduleManagement/Manager/Subwindow_ScheduleManagement_Schedule_Reschedule';
import Subwindow_ScheduleManagement_Schedule_Relocate from '../components/ScheduleManagement/Manager/Subwindow_ScheduleManagement_Schedule_Relocate';
import Subwindow_ScheduleManagement_Schedule_Edit from '../components/ScheduleManagement/Manager/Subwindow_ScheduleManagement_Schedule_Edit';
import Subwindow_ScheduleManagement_Schedule_Approve from '../components/ScheduleManagement/Manager/Subwindow_ScheduleManagement_Schedule_Approve';
import Subwindow_ScheduleManagement_Schedule_Approve_Delegate from '../components/ScheduleManagement/Manager/Subwindow_ScheduleManagement_Schedule_Approve_Delegate';
import Subwindow_Map_ChooseRoom from '../components/InteractiveMap/Subwindow_Map_ChooseRoom';
import Subwindow_Accounts_Choose_Multiple from '../components/AccountManagement/Subwindow_Accounts_Choose_Multiple';

import Panel_ScheduleManagement_Manager_Left from '../components/ScheduleManagement/Manager/Panel_ScheduleManagement_Manager_Left';
import Panel_ScheduleManagement_Manager_Center from '../components/ScheduleManagement/Manager/Panel_ScheduleManagement_Manager_Center';
import Panel_ScheduleManagement_Manager_Right from '../components/ScheduleManagement/Manager/Panel_ScheduleManagement_Manager_Right';

import Icon_Arrow_Left from '../Assets/Icons/Icon_Arrow_Left.png';
import Icon_Requests from '../Assets/Icons/Icon_Requests.png';
import UI_Subwindow_Manager from '../components/ERUMAUI/UI_Subwindow_Manager';
import UI_NavigationRail from '../components/ERUMAUI/UI_NavigationRail';
import UI_Slide_Manager from '../components/ERUMAUI/UI_Slide_Manager';

export default function DR_Main() {
    // const { Page_Properties, Page_Properties_Update } = useContext(Context_App_Properties)
    // const { Page_Properties, Page_Navigation } = useProperties();
    const { Account } = useAuth();
    const { User_Permission } = useAccounts();
    const UI = useContext(Context_UI);
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        // console.log(Page_Properties);
        // window.Page_Properties_Update(Page_Properties);
        // window.Page_Navigation_Update(Page_Navigation);
        // UI.LoadingScreen_Hide("Screen_Loading");
        UI.Page_Navigator_Set(navigate);
        // UI.Initialize();
        UI.LoadingScreen_Hide("Screen_Loading");
        // UI.Slide_Properties_Set("/map_editor");
    }, []);

    const Account_canManage = User_Permission?.Reservation.Edit || User_Permission?.Reservation.Approve.Initial || User_Permission?.Reservation.Final;

    const [Composition_Slide, Composition_Slide_Set] = useState([]);

    useEffect(() => {
        Composition_Slide_Set([
            {
                Slide_ID: "ScheduleManager",
                Panel_Left: <Panel_ScheduleManagement_Manager_Left />,
                Panel_Center: <Panel_ScheduleManagement_Manager_Center />,
                Panel_Right: <Panel_ScheduleManagement_Manager_Right />,
                Active: () => true,
                Ribbon: {
                    Active: () => false,
                    Contents: []
                }
            }
        ]);
        Composition_Navigation_Set([
            {
                Routes: ["/"],
                Destination: "/schedules",
                Icon: Icon_Arrow_Left,
                Text: "Exit schedule manager",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => true
            },
            {
                Routes: ["/schedules/manage"],
                Destination: "/schedules/manage",
                Icon: Icon_Requests,
                Text: "Manage incoming requests",
                hasBadge: false,
                LoadingScreen: false,
                Active: () => true
            }
        ]);
    }, [Account, location.pathname]);

    // Applies to the entire page
    const [Composition_Navigation, Composition_Navigation_Set] = useState([]);

    // Define all the subwindows the page's slides use
    const [Composition_Subwindow, Composition_Subwindow_Set] = useState([
        {
            ID: "Window_General_UnsavedChanges",
            Component: <Subwindow_Modal_UnsavedChanges />
        },
        {
            ID: "Window_ScheduleManagement_Reserve",
            Component: <Subwindow_ScheduleManagement_Reserve />
        },
        {
            ID: "Window_ScheduleManagement_Conflict_Resolve_Standard",
            Component: <Subwindow_ScheduleManagement_Conflict_Resolve_Standard />
        },
        {
            ID: "Window_ScheduleManagement_Schedule_Reschedule",
            Component: <Subwindow_ScheduleManagement_Schedule_Reschedule />
        },
        {
            ID: "Window_ScheduleManagement_Schedule_Relocate",
            Component: <Subwindow_ScheduleManagement_Schedule_Relocate />
        },
        {
            ID: "Window_ScheduleManagement_Schedule_Edit",
            Component: <Subwindow_ScheduleManagement_Schedule_Edit />
        },
        {
            ID: "Window_ScheduleManagement_Attendees",
            Component: <Subwindow_ScheduleManagement_Attendees />
        },
        {
            ID: "Window_ScheduleManagement_Equipment",
            Component: <Subwindow_ScheduleManagement_Equipment />
        },
        {
            ID: "Window_ScheduleManagement_Map",
            Component: <Subwindow_ScheduleManagement_Map />
        },
        {
            ID: "Window_ScheduleManagement_Reserve_Success",
            Component: <Subwindow_ScheduleManagement_Reservation_Success />
        },
        {
            ID: "Window_ScheduleManagement_Document",
            Component: <Subwindow_ScheduleManagement_Document />
        },
        {
            ID: "Window_ScheduleManagement_Reserve_Reject",
            Component: <Subwindow_ScheduleManagement_Reservation_Reject />
        },
        {
            ID: "Window_ScheduleManagement_Reserve_Approve_Delegate",
            Component: <Subwindow_ScheduleManagement_Schedule_Approve_Delegate />
        },
        {
            ID: "Window_ScheduleManagement_Reserve_Approve",
            Component: <Subwindow_ScheduleManagement_Schedule_Approve />
        },
        {
            ID: "Window_Map_ChooseRoom",
            Component: <Subwindow_Map_ChooseRoom />
        },
        {
            ID: "Window_Accounts_Choose_Multiple",
            Component: <Subwindow_Accounts_Choose_Multiple />
        }
    ]);

    return (
        <ui-main>
            <UI_Subwindow_Manager Composition={Composition_Subwindow} />
            <UI_Header />
            <UI_NavigationRail Composition={Composition_Navigation} />
            <UI_Slide_Manager Composition={Composition_Slide} />
        </ui-main>
    )
}